import React from 'react'
import { Link, useLocation } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import headponeshelp from '../assets/images/headphoneshelp.png'
import customerservices from '../assets/images/customer_services.png'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WhyTrust from '../layout/WhyTrust';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';


export default function EquipmentsBooking() {
  const location = useLocation();
  const { product, selectedAttribute } = location.state || {};

  const priceVal = selectedAttribute ? parseFloat(selectedAttribute.price) : 999;
  const taxVal = selectedAttribute ? Math.round(priceVal * 0.05) : 49;
  const securityVal = product ? parseFloat(product.me_security_amount || 0) : 0;
  const totalVal = priceVal + taxVal + securityVal;
  return (
    <>
    <Header/>

     <div className="test_bredcum_sec">
        <div className="container-fluid">
            <div className="test_bredcum">
              <Link to="/">Home</Link>
              <span>&gt;</span>
            <span className='name_p'>Booking</span>
          </div> 
        </div> 
      </div>

      <div className="careplan_content_container">
         <div className="container-fluid">
           <div className="row">
              <div className="col-lg-7 col-md-6 col-12">
                  <div className="left_section_careplan">
                    <h2 className='care_se_heading'><CalendarTodayOutlinedIcon/> Select Duration / Days</h2>
                    <div className="select_day_careplan">
                       <div className="row g-3">

                      <div className="col-6">
                        <div className="care_plan_box">
                          <input type="radio" name="careplan" id="day1" />
                          <label htmlFor="day1">
                            <span className="radio_circle"></span> 
                            <div className="icon_box">
                              <WatchLaterOutlinedIcon/>
                            </div> 
                            <h4>1 Day</h4>
                            <p>Immediate Care Needs</p>
                          </label>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="care_plan_box">
                          <input type="radio" name="careplan" id="day7" defaultChecked />
                          <label htmlFor="day7">
                            <span className="radio_circle"></span> 
                            <div className="icon_box">
                              <WatchLaterOutlinedIcon/>
                            </div> 
                            <h4>7 Day</h4>
                            <p>Weekly Care Plan</p>
                          </label>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="care_plan_box">
                          <input type="radio" name="careplan" id="day15" />
                          <label htmlFor="day15">
                            <span className="radio_circle"></span> 
                            <div className="icon_box">
                              <WatchLaterOutlinedIcon/>
                            </div> 
                            <h4>15 Day</h4>
                            <p>Better Value Care</p>
                          </label>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="care_plan_box">
                          <input type="radio" name="careplan" id="day30" />
                          <label htmlFor="day30">
                            <span className="radio_circle"></span> 
                            <div className="icon_box">
                              <WatchLaterOutlinedIcon/>
                            </div> 
                            <h4>30 Day</h4>
                            <p>Complete Monthly Support</p>
                          </label>
                        </div>
                      </div>

                    </div>
                    </div> 
                    


                    <div className="submit_btn_cp">
                       <button type="submit" className="submit_btn_full">
                          Submit
                      </button>
                    </div>  
                  </div>
                </div>
              <div className="col-lg-5 col-md-6 col-12"> 
                    <div className="long_term_chek_sumery">
                        <div className="uper_sec_header_long">
                            <h3>Your Care Plan Summary</h3>
                        </div>
                        <div className="sumery_content_longterm">
                            <div className="long_term_sev_nme">
                                <h4>Product Name</h4>
                                <h5>{product ? product.me_product_name : "Pulse Oximeter"}</h5>
                            </div>
                             <div className="long_term_sev_nme">
                                <h4>Duration</h4>
                                <h5>{selectedAttribute ? selectedAttribute.attribute_value : "15 Days"}</h5>
                            </div>
                        </div>
                    </div>

                    <div className="long_term_price">
                        <h2>Price</h2>
                        <div className="long_term_sev_nme">
                            <h4>Subtotal</h4>
                            <h5>₹{priceVal.toLocaleString()}</h5>
                        </div>
                        {securityVal > 0 && (
                          <div className="long_term_sev_nme">
                              <h4>Security Deposit</h4>
                              <h5>₹{securityVal.toLocaleString()}</h5>
                          </div>
                        )}
                        <div className="long_term_sev_nme">
                            <h4>Tax amount (5% GST)</h4>
                            <h5>₹{taxVal.toLocaleString()}</h5>
                        </div>
                        <div className="total_payable_longterm">
                            <h4>Total Payable</h4>
                            <h5>₹ {totalVal.toLocaleString()}/-</h5>
                        </div>
                    </div>

                    <div className="discount_section">
                        <input type="radio" id="recommended_plan" name="discount_plan" />

                        <label htmlFor="recommended_plan" className="discount_section_card">
                            <div className="discount_section_left">

                                <div className="discount_section_heading">
                                    <span className="discount_section_star">
                                        <StarOutlinedIcon/>
                                    </span>

                                    <h4>Recommended Plan</h4>

                                    <span className="discount_section_badge">
                                        Save ₹ 500 (20 % Off)
                                    </span>
                                </div>

                                <p>Book for 15 Days and get discount 20% off</p>

                            </div>

                            <div className="discount_section_price">
                                ₹ 1,500/-
                            </div>

                            <span className="discount_section_radio"></span>
                        </label>
                    </div>
                  
                    <div className="policy-btn-box booking_box summary_sec equipment_policy">
                        <div className="icon_content_pb">
                            <VerifiedUserOutlinedIcon/>
                            <div>
                                <h5>Your payment is Safe & Secure</h5>
                                <p>Easy cancellation & 100% refund on eligible cancellations.</p>
                            </div>
                        </div>
                        <div className='police_btn_booking'><a href="#">View Policy <KeyboardArrowRightOutlinedIcon/></a></div> 
                    </div>

                    <div className="total_payble booking_box total_amount_cot">
                        <div className="text_payble">
                            <p>Total Amount</p>
                            <h5>₹ {totalVal.toLocaleString()}/-</h5>
                            <p>(Inclusive of all taxes & security deposit)</p>
                        </div>
                        <div className="book_now_payble">
                            <Link to="/medicinecheckout" state={{ product, selectedAttribute }}>Book Now <EastOutlinedIcon/></Link> 
                        </div>
                    </div>  
              </div>
           </div>
         </div>
      </div>
    
    <div className="why_trust_sec">
        <WhyTrust/>
    </div>
   

    <Footer/>   
    </>
  )
}
